import { ACTION_TYPE, SCHEDULING_MODE, ScheduleActionValue } from './types';

export const DEFAULT_SCHEDULE_ACTION_VALUE: ScheduleActionValue = {
  schedule: {
    mode: SCHEDULING_MODE.deferred,
    type: 'scheduled',
    timeZone: 'America/Mexico_City',
    executeAt: { reference: 'now' },
  },
  actions: [
    {
      type: ACTION_TYPE.notificationEmail,
      templateReference: { moduleId: '', contentId: '' },
      audienceReference: { moduleId: '', contentId: '' },
    },
  ],
};

export const ACTION_TYPE_MODEL = [
  { value: ACTION_TYPE.notificationEmail, item: 'Notificación por correo' },
  { value: ACTION_TYPE.notificationPush, item: 'Notificación push' },
  { value: ACTION_TYPE.notificationInApp, item: 'Notificación in-app' },
  { value: ACTION_TYPE.notificationAiWa, item: 'Notificación AI WhatsApp' },
  { value: ACTION_TYPE.apiCall, item: 'Llamada a un API' },
];

export const SCHEDULING_MODE_MODEL = [
  { value: SCHEDULING_MODE.deferred, item: 'Diferida' },
  { value: SCHEDULING_MODE.immediate, item: 'Inmediata' },
];
